import React from 'react';
import IframeRenderer from "../iframeRenderer";

const VendorScoreDashboardComponent = (props) => {
  const { data } = props;
  const iframeLink = `${data['vendor_score_link']}`;
  return <IframeRenderer iframeLink={iframeLink} />
}

export default VendorScoreDashboardComponent;